import { render, staticRenderFns } from "./payment-transfer-details.vue?vue&type=template&id=075e707f&scoped=true&"
import script from "./payment-transfer-details.vue?vue&type=script&lang=ts&"
export * from "./payment-transfer-details.vue?vue&type=script&lang=ts&"
import style0 from "./payment-transfer-details.vue?vue&type=style&index=0&id=075e707f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e707f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('075e707f')) {
      api.createRecord('075e707f', component.options)
    } else {
      api.reload('075e707f', component.options)
    }
    module.hot.accept("./payment-transfer-details.vue?vue&type=template&id=075e707f&scoped=true&", function () {
      api.rerender('075e707f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_payment-transfer/payment-transfer-details.vue"
export default component.exports